/**
 * Derives the WebSocket base origin (protocol + host) from VITE_BASE_URL.
 *
 * When running via Vite dev server, `window.location.host` points to the
 * dev server (e.g. localhost:5173) while the backend runs behind nginx or
 * directly on another port (configured via VITE_BASE_URL).  WebSocket
 * connections must go to the same host as the API, not the dev server.
 *
 * Falls back to `window.location` when VITE_BASE_URL is unset or relative
 * (i.e. production builds served by nginx).
 */
export function getWebSocketUrl(path: string): string {
    const viteBaseUrl = import.meta.env.VITE_BASE_URL as string | undefined

    if (viteBaseUrl && /^https?:\/\//.test(viteBaseUrl)) {
        const url = new URL(viteBaseUrl)
        const protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
        return `${protocol}//${url.host}${path}`
    }

    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${protocol}//${window.location.host}${path}`
}
